export const environment = {
  production: false,
  apiUrl: 'https://uatllf-mleapi.dhwaniris.in/api',
};
